import React from 'react';
import PropTypes from 'prop-types';

import { Select } from 'common/react/components/select';
import { getTranslation } from 'common/react/utils/translations';

export const LocationDropdown = ({
    items,
    setDropdownData,
    dropdownData,
    handleDropdownChange
}) => {
    return (
        <div className="stats-leaders-nav__select competition-nav__competition-select">
            <Select
                label={getTranslation('label.region-selector.location')}
                items={items}
                itemToString={(item) => item?.name}
                initialSelectedItem={items?.find((item) => {
                    if (item.name) {
                        return (
                            item.name ===
                            PULSE.app.common.modifyCountryDisplay(
                                dropdownData.activeLocation
                            )
                        );
                    }
                    return false;
                })}
                activeItem={items?.find((item) => {
                    if (item.name) {
                        return (
                            item.name ===
                            PULSE.app.common.modifyCountryDisplay(
                                dropdownData.activeLocation
                            )
                        );
                    }
                    return false;
                })}
                onSelectedItemChange={(item) => {
                    setDropdownData((prevState) => {
                        return {
                            ...prevState,
                            activeLocation: item.selectedItem.name,
                            activeRegion: item.selectedItem.extra.name
                        };
                    });
                    handleDropdownChange(item.selectedItem.extra);
                }}
            />
        </div>
    );
};

LocationDropdown.propTypes = {
    items: PropTypes.array,
    setDropdownData: PropTypes.func,
    dropdownData: PropTypes.object,
    handleDropdownChange: PropTypes.func
};
